export default __webpack_public_path__ + "static/media/comcast.75fe6874.svg";